import "./ArHome.scss";
import { useLocation } from "react-router-dom";
import { useEffect, useState, Suspense } from "react";
import ArDb from "./arDb/ArDb";
import ArMatching from "./arMatching/ArMatching";
import ArReceiptHome from "./arReceiptHome/ArReceiptHome";
import AdSysCode from "../ad/adSysCode/AdSysCode";
import { qilloIconMap } from "../../utils/iconMapping";
import AllEntityCatg from "../all/allEntityCatg/AllEntityCatg";
import AllEntityHome from "../all/allEntityHome/AllEntityHome";
import GlCalendar from "../gl/glCalendar/GlCalendar";
import GlCurrency from "../gl/glCurrency/GlCurrency";

const ArHome = ({ menus }) => {
  const location = useLocation();
  const { state } = location;
  const roleMenus = state && state.roleMenus ? state.roleMenus : [];

  const [homeView, setHomeView] = useState(() => {
    const initialView = {
      menu_id: roleMenus[0].group_menus[0]._id,
      menu_function: roleMenus[0].group_menus[0].menu_function,
    };
    const storedView = sessionStorage.getItem("ArHome-homeView");
    return storedView ? JSON.parse(storedView) : initialView;
  });

  useEffect(() => {
    sessionStorage.setItem("ArHome-homeView", JSON.stringify(homeView));
  }, [homeView]);

  // console.log(`ArHome homeView  ${JSON.stringify(homeView, null, 2)}`);

  const handleNavigation = (menuItem) => {
    try {
      setHomeView({
        menu_id: menuItem._id,
        menu_function: menuItem.menu_function,
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="ar-home">
      <div className="ar-home-main-wrapper">
        <div className="left-wrapper">
          <div className="left-content">
            <div className="menu">
              {roleMenus.map((item) => (
                <div className="item" key={item._id}>
                  <span className="title">{item.menu_group_name}</span>
                  {item.group_menus.map((listItem) => {
                    // Access the icon from the map using the icon name
                    const IconComponent = qilloIconMap[listItem.menu_icon];
                    return (
                      <button
                        onClick={() => handleNavigation(listItem)}
                        className={`${homeView.menu_id === listItem._id
                          ? "listItemTitle active"
                          : "listItemTitle"
                          }`}
                        key={listItem._id}
                      >
                        {/* Use Suspense to render the dynamically loaded icon */}
                        <Suspense fallback={<span>Loading...</span>}>
                          <IconComponent className={`${homeView.menu_id === listItem._id
                            ? "listItemIcon active"
                            : "listItemIcon"
                            }`} />
                        </Suspense>
                        <span className={`${homeView.menu_id === listItem._id
                          ? "listItemTitle active"
                          : "listItemTitle"
                          }`}>
                          {listItem.menu_name}
                        </span>
                      </button>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="center-wrapper">
          {homeView.menu_function === "arDb" && <ArDb />}
          {homeView.menu_function === "arReceiptHome" && <ArReceiptHome />}
          {homeView.menu_function === "arMatching" && <ArMatching />}
          {homeView.menu_function === "sysCodes" && <AdSysCode />}
          {homeView.menu_function === "clientsHome" && <AllEntityHome />}
          {homeView.menu_function === "entityCatg" && <AllEntityCatg />}
          {homeView.menu_function === "glCalendar" && <GlCalendar />}
          {homeView.menu_function === "glCurrency" && <GlCurrency />}
        </div>
      </div>
    </div>
  );
};

export default ArHome;
